import React, { useCallback, useEffect } from 'react';
import { toggleExpandedForAll } from 'react-sortable-tree';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import Flex from 'base/components/Flex/index';
import { getAllSpaces } from 'spaces/store/selectors';
import {
  getEditingSid,
  getPermissionTree,
  getEditingRole,
  getManagePermissionsIsLoading,
} from 'auth/store/permissions/selectors';
import {
  fetchPermissionTree,
  fetchPermissionsBySid,
  setPermissionTree,
  fetchAclSids,
  setEditingRoleId,
  setPermissions,
} from 'auth/store/permissions/actions';
import { getFolderIdsBySpaceId, getAllFolderTrees } from 'documents/store/folders/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMatch } from 'react-router';
import PermissionTree from '../components/PermissionTree';
import theme from '../../../theme';

// TODO this needs some major refactoring
export default function ManagePermissions() {
  const dispatch = useAppDispatch();
  const spaces = useAppSelector(getAllSpaces);
  const folderIdsBySpaceId = useAppSelector(getFolderIdsBySpaceId);
  const treeData = useAppSelector(getPermissionTree);
  const folderTreesBySpaceId = useAppSelector(getAllFolderTrees);
  const sid = useAppSelector(getEditingSid);
  const role = useAppSelector(getEditingRole);
  const isLoading = useAppSelector(getManagePermissionsIsLoading);
  const match = useMatch('/admin/permissions/:roleId');
  const roleId = match?.params?.roleId;

  const handleTreeChange = useCallback(
    treeData => {
      dispatch(setPermissionTree(treeData));
    },
    [dispatch],
  );

  const spaceIdsString = spaces.map(space => space.id).join(',');
  const buildPermissionTree = useCallback(() => {
    const treeData =
      spaces.map(space => ({
        type: 'space',
        name: space.name,
        id: space.id,
        children: folderTreesBySpaceId[space.id],
      })) || [];

    handleTreeChange(treeData);
  }, [spaceIdsString, handleTreeChange, folderTreesBySpaceId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(setEditingRoleId(roleId));
    dispatch(fetchAclSids());
    if (sid) {
      dispatch(fetchPermissionTree(sid));
    }
    buildPermissionTree();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sid) {
      dispatch(setPermissions({}));
      dispatch(fetchPermissionsBySid(sid));
      dispatch(fetchPermissionTree(sid));
    }
  }, [dispatch, sid]);

  const folderIdsString = JSON.stringify(folderIdsBySpaceId);
  useEffect(() => {
    // Avoid building the tree before all folder trees are fetched
    if (spaces.length === Object.keys(folderIdsBySpaceId).length) {
      buildPermissionTree();
    }
  }, [buildPermissionTree, folderIdsString]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(setEditingRoleId(roleId));
    // Collapse all tree nodes
    const collapsedTree = toggleExpandedForAll({
      treeData,
      expanded: false,
    });
    handleTreeChange(collapsedTree);
  }, [dispatch, handleTreeChange, roleId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header>
        <MainTitle>
          Permissions <br />
          <span style={{ color: theme.colors.primary }}>{role.name}</span>
        </MainTitle>
      </Header>
      <Flex>{isLoading ? 'Loading...' : <PermissionTree treeData={treeData} onChange={handleTreeChange} />}</Flex>
    </>
  );
}
